import * as utils from '@/library/utils'

export function toLoginPage () {
  location.href = '/login'
}

export function toLoginSuccess () {
  // continue パラメーターがある場合、continueで指定したサイトにリダイレクト
  const continueUrl = utils.getUrlVars().continue
  if (continueUrl) {
    location.href = decodeURIComponent(continueUrl)
  } else {
    location.href = '/'
  }
}

export function toLoginSuccessNoContinue () {
  // 単純にログイン成功時にアカウントサイトのトップにリダイレクト
  location.href = '/'
}
